import React from 'react';
import { IAction } from '../../../../types/Action/IAction';
import { Button, ButtonHandle } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Link } from 'react-router-dom';
import { FileApi } from '../../../../redux/api/FileApi';
import { FileType } from '../../../../types/File/FileType';
import { UserApi } from '../../../../redux/api/UserApi';

const AttachmentButton: React.FC<IAction> = ({ File_Count, ID }) => {
    const { data: isFileActiveInternal } = FileApi.useIsActiveQuery(FileType.Call_Action_Internal)
    const { data: isFileActiveExternal } = FileApi.useIsActiveQuery(FileType.Call_Action_External)
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const isActive = (userProfile?.Features.External_Interface && isFileActiveExternal) || (!userProfile?.Features.External_Interface && isFileActiveInternal);

    const anchor = React.useRef<ButtonHandle | null>(null);
    const [show, setShow] = React.useState(false);
    const handleClick = () => {
        setShow((show) => !show);
    };

    //Close the popup when the user clicks outside of it
    React.useEffect(() => {
        //doesn't work, always closing
        const listener = (e: MouseEvent) => {
            if (!anchor.current?.element.contains(e.target as Node)) {
                setShow(false);
            }
        };


        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, []);

    if (!isActive) return null;
    if (File_Count == 0) return null;

    return (<>

        {/* <Popup popupAlign={{ horizontal: 'right', vertical: 'top' }} anchorAlign={{ horizontal: 'left', vertical: 'top' }}
            anchor={anchor.current && anchor.current.element} style={{ width: 400 }}
            show={show}
            popupClass={'p-4'}
        >
            <FileUpload Primary_Id={ID} FileType={6} />
        </Popup> */}
        {/* <BadgeContainer className='mr-3'>
            <Badge align={{ horizontal: 'end', vertical: 'top' }} >{File_Count}</Badge>
        </BadgeContainer> */}
        <Link to={`action/${ID}/files`}> <Button ref={anchor} svgIcon={svg.paperclipIcon} fillMode='outline' title='Attachments' onClick={handleClick} >{File_Count}</Button></Link>

    </>
    );
};

export default AttachmentButton;